// extracted by mini-css-extract-plugin
module.exports = {"red_x":"DndGallery_red_x__3X3vF","image_holder":"DndGallery_image_holder__5-3gV"};